import React from 'react';
import { TagIcon, RectangleGroupIcon, EnvelopeIcon, ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import { FlowIcon } from '../../../icons/globalIcons';

interface TemplatesMenuItem {
    link: string;
    icon: React.ReactNode;
    text: string;
    childRoutes?: string[];
}

export function getTemplatesMenuItems(): TemplatesMenuItem[] {
    return [
        {
            link: '/super-admin/flow-templates',
            icon: <FlowIcon className="w-6 h-6" />,
            text: 'Flows',
            childRoutes: ['/super-admin/flow-templates/brouillons'],
        },
        {
            link: '/super-admin/email-library',
            icon: <EnvelopeIcon className="w-6 h-6" />,
            text: 'E-mails',
            childRoutes: ['/super-admin/email-library/brouillons'],
        },
        {
            link: '/super-admin/survey-library',
            icon: <ClipboardDocumentListIcon className="w-6 h-6" />,
            text: 'Formulaires',
            childRoutes: ['/super-admin/survey-library/brouillons'],
        },
        {
            link: '/super-admin/flow-template-types',
            icon: <TagIcon className="w-6 h-6" />,
            text: 'Types de flow',
        },
        {
            link: '/super-admin/email-styles',
            icon: <RectangleGroupIcon className="w-6 h-6" />,
            text: 'Matrice styles',
        },
    ];
}
